import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { MatModule } from '../mat.module';

import { OrderComponent } from './order.component';
import { StudiesComponent } from './studies/studies.component';
import { PriorsComponent } from './priors/priors.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { StudyRowComponent } from './studies/study-row/study-row.component';

@NgModule({
    declarations: [OrderComponent, StudiesComponent, PriorsComponent, StudyRowComponent],
    imports: [CommonModule, ReactiveFormsModule, RouterModule, FormsModule, MatModule, MatAutocompleteModule, NgxMatSelectSearchModule],
    providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class OrderModule {}
